import React, { useEffect } from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import _ from 'lodash'

const OatProfilemain = () => {


  useEffect(()=>{

    document.getElementById("name").innerHTML=localStorage.getItem('username')
    document.getElementById("email").innerHTML=localStorage.getItem('email')

  });
   
  console.log(localStorage.getItem('usertoken'));
  


//handleSubmit

  function handleSubmit(event){


    event.preventDefault();

   
    var  CurrentPassword = document.getElementById("CurrentPassword").value;
    
    var NewPassword = document.getElementById("NewPassword").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

    var Confirm = document.getElementById("Confirm").value;


    
    
    if(!CurrentPassword){
      document.getElementById('CurrentErr').innerHTML="Enter Current Password";
     
    }
    
    else{
     
      document.getElementById('CurrentErr').innerHTML=" ";
    }


    if(!NewPassword){
      document.getElementById('NewErr').innerHTML="Enter New Password";
      document.getElementById('NewErrA').innerHTML=" ";
    }
   else if (password1.test(document.getElementById('NewPassword').value)===false){
    document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }
   else if (NewPassword==CurrentPassword){
    document.getElementById('NewErrB').innerHTML="This is Your Current Password";
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
  }


  else {
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }


   if(!Confirm){
    document.getElementById('ConfirmErr').innerHTML="Re-enter Password";
    document.getElementById('ConfirmErrA').innerHTML=" ";
   }
   else if(Confirm != NewPassword){
    document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   else{
    document.getElementById('ConfirmErrA').innerHTML=" ";
    document.getElementById('ConfirmErr').innerHTML=" ";
   
   }

   if(CurrentPassword && (password1.test(document.getElementById('NewPassword').value)===true) && (Confirm == NewPassword)&&(NewPassword!=CurrentPassword) ){




     //change password
  
    
  const body ={currentPassword: CurrentPassword, newPassword:NewPassword}
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

  axios({
         method: "POST",
         url :`${BASE_URL}/Authenticate/ChangePassword`,
         data:body, 
         headers: {
              "Content-Type": "application/json",
              'Authorization':bearer 
          }     
      }) 
  
.then((response) =>{
  console.log(response.data);


 if(response.data.status === "Error"){
     
      // toast.error("InCorrect Password")
      // alert("InCorrect Password")

      
      document.getElementById("IncorrectPass-Oat").style.display="block"
      setTimeout(() => {
        document.getElementById("IncorrectPass-Oat").style.display="none"
       
      }, 3000);
    }

    else if(response.data.status === "Success"){

      // toast.success("Password Change Successfully!", {
      //   position: "top-center",
      //   autoClose: 3200,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   className: 'toast-message'
      //   });

      // alert("Password Change Successfully!")
      changeformclose()
      document.getElementById("PassSuccess-Oat").style.display="block"
        setTimeout(() => {
          document.getElementById("PassSuccess-Oat").style.display="none"
          window.location.href="/#/"
        }, 3000);
     
     

    }
  })
  .catch(error => {
    console.log(error);
    alert("failed !")
  // toast.error("Old Password is Incorrect")   
  })
    

   
   
 
}
} 



//handlechange

  function handlechange(event){

    event.preventDefault();
    var  CurrentPassword = document.getElementById("CurrentPassword").value;
    
    var NewPassword = document.getElementById("NewPassword").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

    var Confirm = document.getElementById("Confirm").value;


    
    if(!CurrentPassword){
      document.getElementById('CurrentErr').innerHTML="Enter Current Password";
     
    }
    
    else{
     
      document.getElementById('CurrentErr').innerHTML=" ";
    }


    if(!NewPassword){
      document.getElementById('NewErr').innerHTML="Enter New Password";
      document.getElementById('NewErrA').innerHTML=" ";
      document.getElementById('NewErrB').innerHTML=" ";
    }
    else if (password1.test(document.getElementById('NewPassword').value)===false){
      document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
      document.getElementById('NewErr').innerHTML=" ";
      document.getElementById('NewErrB').innerHTML=" ";
     }
     else if (NewPassword==CurrentPassword){
      document.getElementById('NewErrB').innerHTML="This is Your Current Password";
      document.getElementById('NewErrA').innerHTML=" ";
      document.getElementById('NewErr').innerHTML=" ";
    }
  
  
    else {
      document.getElementById('NewErrA').innerHTML=" ";
      document.getElementById('NewErr').innerHTML=" ";
      document.getElementById('NewErrB').innerHTML=" ";
     }

   if(!Confirm){
    document.getElementById('ConfirmErr').innerHTML="Re-enter Password";
    document.getElementById('ConfirmErrA').innerHTML=" ";
   }
   else if(Confirm != NewPassword){
    document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   else{
    document.getElementById('ConfirmErrA').innerHTML=" ";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
    
   
  }



   
  


 /*----Function open form----*/

 function Changeformopen(event)

 {
  event.preventDefault();

    document.getElementById("modalRegisterForm").style.display = "block";

  }
  

/*----Function close form----*/

  function changeformclose()

  {

    document.getElementById("CurrentErr").innerHTML=" ";


    document.getElementById("NewErr").innerHTML="  ";  

    document.getElementById("NewErrA").innerHTML="  ";  

    document.getElementById("ConfirmErr").innerHTML="  ";  

    document.getElementById("ConfirmErrA").innerHTML="  ";

    
    document.getElementById('NewErrB').innerHTML=" ";


    document.getElementById("oatform").reset();

     document.getElementById("modalRegisterForm").style.display = "none";

   }

   //eyeicon

   function hide(){
         
    var x = document.getElementById("CurrentPassword");
  
    var eyeCurrent = document.getElementById("eyeCurrent");
    


    if(x.type === "password"){

      x.type = "text";
      eyeCurrent.classList.remove("fa-eye-slash")
      eyeCurrent.classList.add("fa-eye")
      
    }
    else{
      x.type = "password";
      eyeCurrent.classList.remove("fa-eye")
      eyeCurrent.classList.add("fa-eye-slash")
    }

  }
  

   function hideA(){

    var y = document.getElementById("NewPassword");
    var eyeNew = document.getElementById("eyeNew");

    if(y.type === "password"){

      y.type = "text";
      eyeNew.classList.remove("fa-eye-slash")
      eyeNew.classList.add("fa-eye")
      
    }
    else{
      y.type = "password";
      eyeNew.classList.remove("fa-eye")
      eyeNew.classList.add("fa-eye-slash")
    }
   }

   function hideB(){
    var z = document.getElementById("Confirm");
    var eyeConfirm = document.getElementById("eyeConfirm");
    
    if(z.type === "password"){

      z.type = "text";
      eyeConfirm.classList.remove("fa-eye-slash")
      eyeConfirm.classList.add("fa-eye")
      
    }
    else{
      z.type = "password";
      eyeConfirm.classList.remove("fa-eye")
      eyeConfirm.classList.add("fa-eye-slash")
    }

   }
   

  return (
    <>
     <>
    <div className='oat-addmain'>

    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 

<div className="oat-addgrid-layout">
    <div className="oat-addmain-top">
        <div className='oat-addmain-back'>
          
        </div> 
          
           <span className='OatTitle'>
    <span>PROFILE</span></span>
    <div className='oat-addmain-back'>
      <Link to="/OAT"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
     </div>
 </div>
 

  {/* Alert Messages */}
   {/* Register success */}
    
   <div className='oat-toastpop-fade' id="PassSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Password Changed successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>

{/* IncorrectToast */}

<div className='oat-toastpop-fade' id="IncorrectPass-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp;Incorrect Password!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>
 <div>
       <div className="modal-dialog" role="document">
          <div className="modal-content">

           


      
            <form >
    
              <div className="modal-body mx-3">
                  <div className="md-form mb-5">
                
                     <span type="text" className="form-control validate"   id="name" readOnly/>
                     
                  </div>

                  <div className="md-form mb-5">
          
                      <span type="email"  className="form-control validate"  id="email" readOnly />
         
                  </div>

                  
                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="oat-profile-button" onClick={Changeformopen} >Change Password</button>
                  </div>

           </form>



          </div>
     </div>
</div>



<div className="oat-profile-fade" id="modalRegisterForm" tabindex="-1" role="dialog"
  aria-hidden="true">
       <div className="modal-dialog" role="document">
          <div className="modal-content" style={{marginTop:"180px"}}>

            <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">CHANGE PASSWORD</h4>
                <button type="button" className="close" onClick={changeformclose}>
                <span aria-hidden="true">&times;</span>
                </button>
            </div>


      
            <form onSubmit={handleSubmit} id="oatform">
           
              <div className="modal-body mx-3">
                  <div className="md-form mb-5">
         
                    <div style={{display:"flex"}}>
                     <input type="Password" className="form-control validate" onKeyUp={handlechange} placeholder='Current Password' id="CurrentPassword"/>
                     <span className='oat-profile-eyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={hide} id="eyeCurrent"></i></span>
                    
        
                     </div>
                     <span  className='error' id="CurrentErr"></span>
                     
                  </div>

                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>
                      <input type="Password"  className="form-control validate"onKeyUp={handlechange} placeholder='New Password' id="NewPassword" />
                      <span className='oat-profile-eyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={hideA} id="eyeNew"></i></span>
                     
         
                     </div>
                     <span className='error' id="NewErr"></span>
                     <span className='error' id="NewErrA"></span>
                     <span className='error' id="NewErrB"></span>
                  </div>

                  <div className="md-form mb-5">
          
                  <div style={{display:"flex"}}>
                      <input type="Password" className="form-control validate" onKeyUp={handlechange}  placeholder='Confirm Password'  id="Confirm"/>
                      <span className='oat-profile-eyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={hideB} id="eyeConfirm"></i></span>
                    
         
                  </div>
                  <span className='error' id="ConfirmErr"></span>
                     <span  className='error' id="ConfirmErrA"></span>
                  </div>   

                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="oat-adduser-button" >Submit</button>
                  </div>

             </form>



          </div>
     </div>
</div>

 
 </div>
 </>
   
     
        
      </>
  )
}

export default OatProfilemain
